import { request } from '@nextgen-web-framework/core';
import {
  ApiProjections,
  ProjectionReqPayloadType,
  SharebarResponse,
  SharecodeReqPayloadType,
  AddSharecodeReqPayloadType,
  UpdateCustomizeSharecodeResponse,
  UpdateCustomSharecodeRequestPayloadType,
} from '../../../types/sharebarTypes';
import { createSharebarReqObj, getSharebarReqObj, updateCustomSharecodeReqObj, getChannelConfig } from '../../config';
import type { AdvanceShareCodeResponse, UpdateShareCodeResponse, ChannelConfigs } from '../../models';
export interface ISharebarAPI {
  sharecodeid: string;
  projections?: string;
}

export const sharebarApi = {
  async getSharecodeDetails({
    sharecodeid,
    sharecode,
    projections = ApiProjections.ALL,
  }: SharecodeReqPayloadType & ProjectionReqPayloadType): Promise<SharebarResponse> {
    if (!sharecode && !sharecodeid) {
      return Promise.reject({
        message: 'Please check arguments - Either sharecode or sharecodeid should present.',
      });
    }
    const req = { ...getSharebarReqObj({ sharecode, sharecodeid, projections }) };
    return await request<AdvanceShareCodeResponse>(req);
  },

  async updateCustomSharecode({
    payload,
  }: UpdateCustomSharecodeRequestPayloadType): Promise<UpdateCustomizeSharecodeResponse> {
    const req = { ...updateCustomSharecodeReqObj };
    req.body = payload as BodyInit;
    return await request<UpdateShareCodeResponse>(req);
  },

  async createSharebar({ payload }: AddSharecodeReqPayloadType): Promise<SharebarResponse> {
    const req = { ...createSharebarReqObj };
    req.body = payload as BodyInit;
    return await request<AdvanceShareCodeResponse>(req);
  },

  async getChannelConfig(): Promise<ChannelConfigs> {
    const req = { ...getChannelConfig };
    return await request<ChannelConfigs>(req);
  },
};

export default sharebarApi;
